import React from "react"
import { Link } from "react-router-dom"
import { Button, Table, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from '../../tool/axios'
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'

const { Column } = Table

interface State {
    data: object[],
    loading: boolean,

    pagination: {
        current: number,
        pageSize: number,
        total: number
    },

    fetchOtherParams: {
        store_id: string | undefined
    },

    permissionList: string[]
}

export default class CkFixList extends React.Component {
    state: State = {
        data: [],
        loading: false,
        pagination: {
            current: 1,
            pageSize: 8,
            total: 0
        },
        fetchOtherParams: {
            store_id: undefined
        },
        permissionList: []
    }

    componentDidMount() {
        this.setState({
            permissionList: getPermission()
        })

        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleSelectStoreChange(value: string, attr: string) {
        let { fetchOtherParams }: { fetchOtherParams: any } = this.state
        fetchOtherParams[attr] = value

        this.setState({ fetchOtherParams })
    }

    handleSearch() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        this.setState({ pagination }, () => {
            this.fetch({ pagination, fetchOtherParams })
        })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/chankang_center/recover_list/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state

                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    data: response.records
                })
            }
        })
    }

    resetForm() {
        let { pagination, fetchOtherParams } = this.state
        pagination.current = 1

        fetchOtherParams = {
            store_id: undefined
        }

        this.setState({
            pagination,
            fetchOtherParams
        })

        this.fetch({ pagination, fetchOtherParams })
    }

    render() {
        let { store_id } = this.state.fetchOtherParams
        let permissionList = this.state.permissionList

        return (<div className="common-page">
            {/* 产康中心 -> 产康员工管理 -> 产康师管理 */}
            <BreadCrumb position={['产康中心', '产康师管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <div style={{ marginRight: 8, marginBottom: 12 }}>
                        <SelectStores onChange={(value: string) => { this.handleSelectStoreChange(value, 'store_id') }} value={store_id} valueProp="id" />
                    </div>

                    {permissionList.includes('查询') && <Button className="search-btn" style={{ marginRight: 5, marginBottom: 12 }} icon={<SearchOutlined />} onClick={this.handleSearch.bind(this)}>查询</Button>}
                    <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                </Space>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="employee_id" pagination={this.state.pagination} onChange={this.handleTableChange}>
                    <Column title="门店" dataIndex="belong_store_name" key="belong_store_name" />
                    <Column title="姓名" dataIndex="user_name" key="user_name" />
                    <Column title="手机号" dataIndex="phone" key="phone" />
                    <Column title="入职时间" dataIndex="in_date" key="in_date" />

                    <Column
                        title="操作"
                        key="action"
                        render={(text, record: { employee_id: string }) => (
                            <Space size="middle">
                                {permissionList.includes('设置') && <Button type="primary" ><Link to={"/set_ck_fix_master/" + record.employee_id}>编辑</Link></Button>}
                            </Space>
                        )}
                    />
                </Table>
            </div>
        </div>)
    }
}